import { API } from '../api'
import { DeliveryParams } from './interface'

export const patch = async (
  filtros: Record<string, any>
): Promise<{
  conteudo: string
  sucesso: boolean
}> => {
  try {
    const formData = new FormData()
    formData.append('agrupamentoId', filtros.agrupamentoId)
    formData.append('alteradoPor', filtros.alteradoPor)
    formData.append('comprovanteDeEntrega', filtros.comprovanteDeEntrega)
    formData.append('dataDaEntrega', filtros.dataDaEntrega)
    formData.append('recebidoPor', filtros.recebidoPor)

    const response = await API.patch<DeliveryParams>(
      '/logistica/item/confirmar-entrega',
      filtros,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )

    return {
      conteudo: response?.content,
      sucesso: response?.isSuccess
    }
  } catch (error) {
    console.error('Erro ao solicitar entrega:', error)
    return {
      conteudo: null,
      sucesso: false
    }
  }
}
